<template>
  <mds-layout-grid>
    <filter-section />
    <table-section />
  </mds-layout-grid>
</template>

<script>
import FilterSection from '@/components/providers/filters/FilterSection';
import TableSection from '@/components/providers/table/TableSection';

export default {
  name: 'ProvidersPage',
  components: {
    FilterSection,
    TableSection,
  },
};
</script>
